<template>
    <div>
        <!-- 
        titulo: 'Resumen tarjetas de cr[edito]',
        datos: this.resumenData -->
        <v-col cols="12" sm="12" md="12" lg="12">
            <v-card flat>
                <v-card-text>
                    <h2>Tarjetas de credito (tardeudaT1, tardeudaT2, tardeudaT3, tardeudaT4) ({{
                        resumenDataTarjetasDeCredito.length }})</h2>
                    <v-data-table :items-per-page="-1" :headers="resumenHeadersTarjetasDeCredito"
                        :items="resumenDataTarjetasDeCredito" dense class="mt-3" hide-default-footer
                        :item-class="(item) => Number(item?.saldoMora ?? 0) > 0 ? 'fila-mora' : ''"></v-data-table>
                </v-card-text>
            </v-card>
        </v-col>
        <!-- 
        titulo: 'Resumen bancos',
        datos: this.resumenData -->
        <v-col cols="12" sm="12" md="12" lg="12">
            <v-card flat>
                <v-card-text>
                    <h2>Bancos(bandeudaD1, bandeudaD2, bandeudaD3, bandeudaD4) ({{
                        resumenDataBancos.length }})</h2>
                    <v-data-table :items-per-page="-1" :headers="resumenHeadersBancos" :items="resumenDataBancos" dense
                        class="mt-3" hide-default-footer
                        :item-class="(item) => Number(item?.saldoMoraCapital ?? 0) > 0 ? 'fila-mora' : ''"></v-data-table>
                </v-card-text>
            </v-card>
        </v-col>
        <!-- 
        titulo: 'Resumen otros creditos',
        datos: this.resumenData -->
        <v-col cols="12" sm="12" md="12" lg="12">
            <v-card flat>
                <v-card-text>
                    <h2>Otros creditos (deucomerd1, deucomerd2, deucomerd3, deucomerd4) ({{ resumenDataOtros.length }})
                    </h2>
                    <v-data-table :items-per-page="-1" :headers="resumenHeadersOtros" :items="resumenDataOtros" dense
                        class="mt-3" hide-default-footer
                        :item-class="(item) => Number(item?.saldoMora ?? 0) > 0 ? 'fila-mora' : ''"></v-data-table>
                </v-card-text>
            </v-card>
        </v-col>

        <!-- 
        titulo: 'Resumen otros creditos',
        datos: this.resumenData -->
        <v-col cols="12" sm="12" md="12" lg="12">
            <v-card flat>
                <v-card-text>
                    <h2>Consultas ({{ resumenDataConsultas.length }})
                    </h2>
                    <v-data-table :items-per-page="-1" :headers="resumenHeaderConsultas" :items="resumenDataConsultas" dense
                        class="mt-3" hide-default-footer
                        :item-class="(item) => Number(item?.saldoMora ?? 0) > 0 ? 'fila-mora' : ''"></v-data-table>
                </v-card-text>
            </v-card>
        </v-col>


        <!-- <div
            v-if="VUE_APP_FEATHERS_SERVER != 'http://192.168.19.100:3030/' && VUE_APP_FEATHERS_SERVER != 'http://192.168.19.103:3038/'">
            calculates
            <pre>
            {{ Object.keys(JSON.parse(infotablas_segun_perfil).calculates).length }}
        </pre>
            tarjetas
            tardeudaT1: {{
                JSON.parse(infotablas_segun_perfil).infoCrediticia.tardeudaT1.length +
                JSON.parse(infotablas_segun_perfil).infoCrediticia.tardeudaT2.length +
                JSON.parse(infotablas_segun_perfil).infoCrediticia.tardeudaT3.length +
                JSON.parse(infotablas_segun_perfil).infoCrediticia.tardeudaT4.length }}
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.tardeudaT1 }}
        </pre>
            [2]
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.tardeudaT2 }}
        </pre>
            [3]
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.tardeudaT3 }}
        </pre>
            [4]
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.tardeudaT4 }}
        </pre>
            banca
            [1]
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.bandeudaB1 }}
        </pre>
            [2]
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.bandeudaB2 }}
        </pre>
            [3]
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.bandeudaB3 }}
        </pre>
            [4]
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.bandeudaB4 }}
        </pre>
            otros creditos
            [1]
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.deucomerD1 }}
        </pre>
            [2]
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.deucomerD2 }}
        </pre>
            [3]
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.deucomerD3 }}
        </pre>
            [4]
            <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.deucomerD4 }}
        </pre>
        </div> -->

        <!-- <pre>
            {{ JSON.parse(infotablas_segun_perfil).infoCrediticia.consulta }}
        </pre> -->
        <p class="text-body-2 text--secondary mt-2">
            Nombre de la Persona:: {{ equifax_json.candidateInfo.nombre }}
            <br>
            {{ documento_de_identificacion }}: {{ detalleEvaluacion.dpi }}
            <br>
            Fecha de nacimiento: {{ descomponerFecha(equifax_json.candidateInfo.fechaNacimiento) }}
            <br>
            Periodo: {{ equifax_json.infoCrediticia.periodo[0].periodoActual }}
            <br>
            Reporte:
            <v-btn x-small :href="VUE_APP_FEATHERS_SERVER + reporteURL" target="_blank" download color="primary"
                class="ma-2">
                <v-icon small left>mdi-download</v-icon>
                Descargar Reporte
            </v-btn>
        </p>

        <h2 class="mt-2 mb-3">Scores</h2>
        <v-data-table dense :headers="calculatesHeaders" :items="[equifax_json.calculates]" class="elevation-1"
            :search="calculatesSearch" :custom-filter="customFilter" :hide-default-footer="true">
            <template v-slot:top>
                <v-text-field v-model="calculatesSearch" label="Buscar en Calculates" class="mx-4"></v-text-field>
            </template>
        </v-data-table>

        <h2 class="mt-2 mb-3">Score Actual</h2>
        <v-data-table :items-per-page="equifax_json_actual.length" dense :headers="scoreActualHeaders"
            :items="equifax_json_actual" class="elevation-1" :search="scoreActualSearch" :custom-filter="customFilter"
            :hide-default-footer="true">
            <template v-slot:top>
                <v-text-field v-model="scoreActualSearch" label="Buscar en Score Actual" class="mx-4"></v-text-field>
            </template>
        </v-data-table>

        <h2 id="equifax_historico_titulo" class="mt-2 mb-3">Score Histórico</h2>
        <v-data-table id="equifax_historico_tabla" :items-per-page="equifax_json_historico.length" dense
            :headers="scoreHistoricoHeaders" :items="equifax_json_historico" class="elevation-1"
            :search="scoreHistoricoSearch" :custom-filter="customFilter" :hide-default-footer="true">
            <template v-slot:top>
                <v-text-field v-model="scoreHistoricoSearch" label="Buscar en Score Histórico"
                    class="mx-4"></v-text-field>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: ['reporteURL', 'detalleEvaluacion', 'equifax_json_actual', 'equifax_json_historico', 'equifax_json', 'infotablas_segun_perfil'],
    data() {
        return {
            /** */
            resumenDataConsultas: [],
            resumenHeaderConsultas: [
                { text: 'Nombre Entidad', value: 'nombreEntidad' },
                { text: 'Código Fuente', value: 'codigoFuente' },
                { text: 'Estado Crédito', value: 'codigoOficina' },
                { text: 'Periodo Información', value: 'periodoInformacion' },
                { text: 'Código Sector', value: 'codigoSector' },
                { text: 'Fecha Operacion', value: 'fechaOperacion' },
            ],

            resumenDataBancos: [],
            resumenHeadersBancos: [
                { text: 'Saldo Referencia', value: 'saldoReferencia' },
                { text: 'Días Atraso', value: 'diasAtraso' },
                { text: 'Estado Crédito', value: 'estadoCredito' },
                { text: 'Fecha Fin MOIN', value: 'fechaFinMoin' },
                { text: 'Fecha Otorgamiento', value: 'fechaOtorgamiento' },
                { text: 'Fecha Fin MOCA', value: 'fechaFinMoca' },
                { text: 'Tipo Crédito', value: 'TIPO_CRED' },
                { text: 'Periodo Información', value: 'periodoInformacion' },
                { text: 'Fecha Cancelado', value: 'fechaCancelado' },
                { text: 'Bandera Cancelado', value: 'BAND_CANC' },
                { text: 'Tasa Contado', value: 'tasaContado' },
                { text: 'Saldo Vigente Interés', value: 'saldoVigenteInteres' },
                { text: 'Número Referencia', value: 'numeroReferencia' },
                { text: 'Saldo Vencido Interés', value: 'saldoVencidoInteres' },
                { text: 'Código Categoría', value: 'CODI_CATE' },
                { text: 'Tipo Garantía', value: 'tipoGarantia' },
                { text: 'Código Destino', value: 'codigoDestino' },
                { text: 'Cuota Referencia', value: 'cuotaReferencia' },
                { text: 'Fecha Inicio MOIN', value: 'fechaInicioMoin' },
                { text: 'Tipo Tasa', value: 'tipoTasa' },
                { text: 'Saldo Vigente Capital', value: 'saldoVigenteCapital' },
                { text: 'Código Fuente', value: 'codigoFuente' },
                { text: 'Saldo Vencido Capital', value: 'saldoVencidoCapital' },
                { text: 'Fecha Inicio MOCA', value: 'fechaInicioMoca' },
                { text: 'Monto Referencia', value: 'montoReferencia' },
                { text: 'Saldo Mora Interés', value: 'saldoMoraInteres' },
                { text: 'Código Actividad', value: 'codigoActividad' },
                { text: 'Código Categoría', value: 'codigoCategoria' },
                { text: 'Forma Pago Interés', value: 'formaPagoInteres' },
                { text: 'Tasa Interés', value: 'tasaInteres' },
                { text: 'Tasa Efectiva', value: 'tasaEfectiva' },
                { text: 'Tipo Préstamo', value: 'tipoPrestamo' },
                { text: 'Fecha Vencimiento', value: 'fechaVencimiento' },
                { text: 'Saldo Mora Capital', value: 'saldoMoraCapital' },
                { text: 'Tasa Referencia', value: 'tasaReferencia' },
                { text: 'Código Moneda', value: 'codigoMoneda' },
                { text: 'Forma Pago Capital', value: 'formaPagoCapital' },
                { text: 'Días Mora Interés', value: 'diasMoraInteres' },
                { text: 'Fecha Castigado', value: 'fechaCastigado' },
                { text: 'Destino Crédito', value: 'destinoCredito' },
                { text: 'Días Mora Capital', value: 'diasMoraCapital' }
            ],

            resumenDataOtros: [],
            resumenHeadersOtros: [
                { text: 'Grupo', value: 'grupo' },
                { text: 'Código Fuente', value: 'codigoFuente' },
                { text: 'Tipo Entidad', value: 'tipoEntidad' },
                { text: 'Clase de Deuda', value: 'claseDeuda' },
                { text: 'Monto Original', value: 'montoOriginal' },
                { text: 'Saldo Mora', value: 'saldoMora' },
                { text: 'Monto Cuota', value: 'montoCuota' },
                { text: 'Cuota Capital', value: 'cuotaCapital' },
                { text: 'Fecha MOCA', value: 'FECH_MOCA' },
                { text: 'Código Destino', value: 'codigoDestino' },
                { text: 'Fecha Vencimiento', value: 'fechaVencimiento' },
                { text: 'Número Cuenta', value: 'numeroCuenta' },
                { text: 'Saldo Mora Capital', value: 'saldoMoraCapital' },
                { text: 'Fecha Mora', value: 'fechaMora' },
                { text: 'Número Cuota', value: 'numCuota' },
                { text: 'Periodo Información', value: 'periodoInformacion' },
                { text: 'Cuota Interés', value: 'cuotaInteres' },
                { text: 'Saldo Deuda', value: 'saldoDeuda' },
                { text: 'Fecha Cancelación', value: 'fechaCancelacion' },
                { text: 'Código Moneda', value: 'codigoMoneda' },
                { text: 'Estado Crédito', value: 'estadoCredito' },
                { text: 'Categoría Riesgo', value: 'categoriaRiesgo' },
                { text: 'Fecha Info', value: 'fechaInfo' },
                { text: 'Tipo Deuda', value: 'tipoDeuda' },
                { text: 'Fecha Apertura', value: 'fechaApertura' },
                { text: 'Fecha MOIN', value: 'FECH_MOIN' },
                { text: 'Saldo Mora Interés', value: 'saldoMoraInteres' }
            ],
            resumenDataTarjetasDeCredito: [],
            resumenHeadersTarjetasDeCredito: [
                { text: 'Grupo', value: 'grupo' },
                { text: 'Código Fuente', value: 'codigoFuente' },
                { text: 'Fecha MOIN', value: 'fechaMoIn' },
                { text: 'Saldo Mora', value: 'saldoMora' },
                { text: 'Cuota Capital', value: 'cuotaCapital' },
                { text: 'Descripción Tarjeta', value: 'descripcionTarjeta' },
                { text: 'Saldo Mora Capital', value: 'saldoMoraCapital' },
                { text: 'Fecha Mora', value: 'fechaMora' },
                { text: 'Fecha MOCA', value: 'fechaMoCa' },
                { text: 'Tipo Cliente', value: 'tipoCliente' },
                { text: 'Periodo Información', value: 'periodoInformacion' },
                { text: 'Cuota Interés', value: 'cuotaInteres' },
                { text: 'Fecha Cancelación', value: 'fechaCancelacion' },
                { text: 'Pago Mínimo', value: 'pagoMinimo' },
                { text: 'Plazo Meses', value: 'plazoMeses' },
                { text: 'Número Referencia', value: 'numeroReferencia' },
                { text: 'Estado Crédito', value: 'estadoCredito' },
                { text: 'Límite Dólares', value: 'limiteDolares' },
                { text: 'Categoría Riesgo', value: 'categoriaRiesgo' },
                { text: 'Fecha Info', value: 'fechaInfo' },
                { text: 'Conteo Mora', value: 'conteoMora' },
                { text: 'Tipo Tarjeta', value: 'tipoTarjeta' },
                { text: 'Tasa Interés Mensual', value: 'tasaInteresMensual' },
                { text: 'Tasa Interés Anual', value: 'tasaInteresAnual' },
                { text: 'Fecha Apertura', value: 'fechaApertura' },
                { text: 'Saldo Dólares', value: 'saldoDolares' },
                { text: 'Saldo Mora Interés', value: 'saldoMoraInteres' },
                { text: 'Conteo Sobregiro', value: 'conteoSobregiro' }
            ],


            /** */
            // Filtros de búsqueda
            calculatesSearch: "",
            scoreActualSearch: "",
            scoreHistoricoSearch: "",



            // Definición de encabezados para tablas
            calculatesHeaders: [
                { text: "be_score_prom", value: "be_score_prom" },
                { text: "be_score", value: "be_score" },
            ],
            scoreActualHeaders: [
                { text: "Tipo de Score", value: "TYPE_SCORE" },
                { text: "Periodo Información", value: "PERI_INFO" },
                { text: "Mensaje 1", value: "MESSAGE_1" },
                { text: "Mensaje 2", value: "MESSAGE_2" },
                { text: "Mensaje 3", value: "MESSAGE_3" },
                { text: "Score", value: "SCORE" },
                { text: "Número de Identificación", value: "NUME_NIDE" },
            ],
            scoreHistoricoHeaders: [
                { text: "Tipo de Score", value: "tipoScore" },
                { text: "Periodo Información", value: "periodoInformacion" },
                { text: "Mensaje 1", value: "message1" },
                { text: "Mensaje 2", value: "message2" },
                { text: "Valor Score", value: "valorScore" },
            ],

            // Datos de las tablas, que serán asignados dinámicamente
            scoreActualData: [],
            scoreHistoricoData: []
        };
    },
    computed: {
        documento_de_identificacion() {
            if (this.detalleEvaluacion.pais == 'Guatemala') {
                return 'DPI'
            } else if (this.detalleEvaluacion.pais == 'El Salvador') {
                return 'DUI'
            } else {
                return 'Documento de identificación'
            }
        },
        VUE_APP_FEATHERS_SERVER() {
            return process.env.VUE_APP_FEATHERS_SERVER;
        },
    },
    methods: {
        /** */
        getRowClass(item) {
            return parseInt(item.saldoMora) > 0 ? 'fila-mora' : 'fila-mora'
        },
        /** */
        fnLoadCreditosTarjetasDeCredito() {
            const detalle = JSON.parse(this.infotablas_segun_perfil).infoCrediticia;

            this.resumenDataTarjetasDeCredito = [
                ...detalle.tardeudaT1.map(item => ({ grupo: "T1", ...item })),
                ...detalle.tardeudaT2.map(item => ({ grupo: "T2", ...item })),
                ...detalle.tardeudaT3.map(item => ({ grupo: "T3", ...item })),
                ...detalle.tardeudaT4.map(item => ({ grupo: "T4", ...item }))
            ];
        },

        fnLoadCreditosOtros() {
            const detalle = JSON.parse(this.infotablas_segun_perfil).infoCrediticia;

            this.resumenDataOtros = [
                ...detalle.deucomerD1.map(item => ({ grupo: "D1", ...item })),
                ...detalle.deucomerD2.map(item => ({ grupo: "D2", ...item })),
                ...detalle.deucomerD3.map(item => ({ grupo: "D3", ...item })),
                ...detalle.deucomerD4.map(item => ({ grupo: "D4", ...item }))
            ];
        },

        fnLoadCreditosBancos() {
            const detalle = JSON.parse(this.infotablas_segun_perfil).infoCrediticia;

            this.resumenDataBancos = [
                ...detalle.bandeudaB1.map(item => ({ grupo: "B1", ...item })),
                ...detalle.bandeudaB2.map(item => ({ grupo: "B2", ...item })),
                ...detalle.bandeudaB3.map(item => ({ grupo: "B3", ...item })),
                ...detalle.bandeudaB4.map(item => ({ grupo: "B4", ...item }))
            ];
        },
        fnLoadConsultas() {
            const detalle = JSON.parse(this.infotablas_segun_perfil).infoCrediticia;

            this.resumenDataConsultas = [
                ...detalle.consulta.map(item => (item)),
            ];
        },
        descomponerFecha(fechaString) {
            if (fechaString.length !== 8) {
                throw new Error("La cadena debe tener exactamente 8 caracteres en el formato DDMMYYYY.");
            }

            const dia = fechaString.slice(0, 2);
            const mes = fechaString.slice(2, 4);
            const anio = fechaString.slice(4, 8);

            return `${dia}/${mes}/${anio}`;
        },
        // Filtro personalizado para búsquedas por columna
        // eslint-disable-next-line no-unused-vars
        customFilter(value, search, item) {
            if (!search) return true;
            return String(value).toLowerCase().includes(search.toLowerCase());
        },

        // Función para procesar el JSON y asignar los datos a las tablas
        loadDataFromJson(jsonData) {
            // Extrae ScoreActual y scoreHistorico si existen
            this.scoreActualData = jsonData.infoCrediticia?.ScoreActual || [];
            this.scoreHistoricoData = jsonData.infoCrediticia?.scoreHistorico || [];
        }
    },

    created() {
        this.fnLoadCreditosTarjetasDeCredito();
        this.fnLoadCreditosOtros();
        this.fnLoadCreditosBancos();
        this.fnLoadConsultas();
        //   // Ejemplo de JSON dinámico; reemplaza esto con el JSON real que recibas
        //   const dynamicJson = {
        //     infoCrediticia: {
        //       ScoreActual: [
        //         {
        //           TYPE_SCORE: "8",
        //           PERI_INFO: "797589",
        //           MESSAGE_3: "",
        //           MESSAGE_2: "Relación entre el pago mínimo y el límite",
        //           MESSAGE_1: "Tendencia creciente en días de mora de productos TC",
        //           SCORE: "23",
        //           NUME_NIDE: "2000378435"
        //         }
        //       ],
        //       scoreHistorico: [
        //         {
        //           message2: "EXPERIENCIA CREDITICIA",
        //           tipoScore: 7,
        //           message1: "UTILIZACION DE PRODUCTOS",
        //           valorScore: 2470,
        //           periodoInformacion: 202409
        //         }
        //       ]
        //     }
        //   };

        //   // Cargar datos en las tablas
        //   this.loadDataFromJson(dynamicJson);
    }
};
</script>
<style>
.fila-mora {
    background-color: #ffebee;
    /* un rojo muy suave */
    color: #b71c1c;
    /* texto rojo oscuro opcional */
}
</style>